module.exports = __webpack_public_path__ + "img/0x5D4360f1Be94bD6f182F09cFE5EF9832e65EB1ac.f9c161b2.png";